import React, { FC, HTMLAttributes } from "react";
import NumberFormat from "react-number-format";
import styled from "styled-components";
import { FastField, FieldInputProps, FieldMetaProps } from "formik";

type Props = HTMLAttributes<HTMLDivElement> & {
  name: string;
};

const InputText: FC<Props> = ({ name, ...rest }) => (
  <FastField name={name}>
    {({ field, meta }: { field: FieldInputProps<string>; meta: FieldMetaProps<string> }) => (
      <Root {...rest}>
        <InputContainer>
          <Input {...field} type="tel" thousandSeparator isAllowed={({ floatValue }) => !floatValue || floatValue < 10000000000} />
          <Suffix>円</Suffix>
        </InputContainer>
        {meta.touched && meta.error && (<Error>{meta.error}</Error>)}
      </Root>
    )}
  </FastField>
);
export default InputText;

const Root = styled.div`
  
`;

const Error = styled.div`
  margin-top: 5px;
  color: red;

  @media screen and (max-width: 960px) {
    font-size: 12px;
  }

  @media screen and (min-width: 961px) {
    font-size: 14px;
  }
`;

const InputContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  background-color: white;
  border: 2px solid #777;
  border-radius: 20px;
  padding: 4px 1em;
`;

const Suffix = styled.span`
  font-size: 14px;
  font-weight: bold;
  margin-left: 2px;

  @media screen and (max-width: 960px) {
    margin-bottom: 2.8px;
  }

  @media screen and (min-width: 961px) {
    margin-bottom: 3.2px;
  }
`;

const Input = styled(NumberFormat)`
  width: 100%;
  color: #777;
  font-size: 1.24em;
  padding: 4px 0;
  height: 1.24em;
`;
